exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".Tooltip__Tooltip__1Yidvf {\n  display: inline-block;\n}\n.Tooltip__tooltipBody__Oa1hc4 {\n  position: absolute;\n  background: #fff;\n  color: #4a4a4a;\n  border: 1px solid #ddd;\n  border-radius: 1px;\n  padding: 10px;\n  font-size: 12px;\n  z-index: 200;\n}\n.Tooltip__tooltipBody__Oa1hc4 .Tooltip__arrowRight__3cAlo4 {\n  top: 50%;\n  left: 0;\n  margin-top: -5px;\n  border-width: 5px 5px 5px 0;\n  border-right-color: #000;\n}\n.Tooltip__tooltipLabel__3BCX_r i {\n  margin-left: 10px;\n}\n.Tooltip__tooltipLabel__3BCX_r i:hover {\n  color: #183049;\n}\n.dark .Tooltip__tooltipLabel__3BCX_r span:hover,\n.dark .Tooltip__tooltipLabel__3BCX_r i:hover {\n  color: #fff;\n}\n", ""]);

// exports
exports.locals = {
	"Tooltip": "Tooltip__Tooltip__1Yidvf",
	"tooltipBody": "Tooltip__tooltipBody__Oa1hc4",
	"arrowRight": "Tooltip__arrowRight__3cAlo4",
	"tooltipLabel": "Tooltip__tooltipLabel__3BCX_r"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./node_modules/postcss-loader/src??ref--2-2!./node_modules/stylus-loader!./web_modules/trustar/components/Tooltip.styl
// module id = 3582
// module chunks = 39